var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoAppliSimpleSoluspots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105.624,
    height: 105.597,
    viewBox: "0 0 105.624 105.597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_714",
    "data-name": "Groupe 714",
    transform: "translate(-542.956 -1901.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_705",
    "data-name": "Groupe 705",
    transform: "translate(542.956 1901.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5172",
    "data-name": "Trac\\xE9 5172",
    d: "M625.493,1960.014l-3.454-.378c.145-1.32.231-2.411.274-3.433a49.4,49.4,0,0,0-47.306-51.3l.14-3.474a52.882,52.882,0,0,1,50.637,54.913C625.739,1957.448,625.647,1958.614,625.493,1960.014Z",
    transform: "translate(-520.204 -1901.43)",
    fill: "#41c850"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5173",
    "data-name": "Trac\\xE9 5173",
    d: "M544.218,1963.394a51.568,51.568,0,0,1-1.229-13.144,58.185,58.185,0,0,1,3-15.57A53.064,53.064,0,0,1,574.546,1904l1.4,3.182a49.568,49.568,0,0,0-26.685,28.656,55.2,55.2,0,0,0-2.8,14.529,47.981,47.981,0,0,0,1.146,12.258Z",
    transform: "translate(-542.956 -1899.603)",
    fill: "#41c850"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5174",
    "data-name": "Trac\\xE9 5174",
    d: "M574.884,1974.189q-1.147,0-2.3-.05l.151-3.469a48.545,48.545,0,0,0,14.6-1.589c15.4-4.155,24.853-15.187,29.118-21.392l2.864,1.968c-4.536,6.6-14.6,18.334-31.077,22.779A51.23,51.23,0,0,1,574.884,1974.189Z",
    transform: "translate(-521.923 -1868.591)",
    fill: "#41c850"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_713",
    "data-name": "Groupe 713",
    transform: "translate(548.043 1907.143)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 39.926,
    cy: 39.926,
    r: 39.926,
    transform: "translate(0 78.065) rotate(-77.858)",
    fill: "#e9eaeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_706",
    "data-name": "Groupe 706",
    transform: "translate(61.017 21.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5175",
    "data-name": "Trac\\xE9 5175",
    d: "M584.085,1931.247l-.313-.328c-1.6-1.688-1.775-4.148-.385-5.468l5.916-5.584c2.141-2.033,5.2-2.315,6.805-.627l.311.328c1.6,1.688,1.161,4.731-.98,6.764l-5.916,5.583C588.134,1933.234,585.685,1932.935,584.085,1931.247Z",
    transform: "translate(-581.025 -1916.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5176",
    "data-name": "Trac\\xE9 5176",
    d: "M587.934,1934.754a4.982,4.982,0,0,1-.634-.041,6.125,6.125,0,0,1-3.659-1.894l-.311-.327c-2.148-2.264-2.3-5.62-.333-7.486l5.92-5.586c2.71-2.575,6.668-2.833,8.816-.573l.313.328a5.277,5.277,0,0,1,1.291,4.439,7.561,7.561,0,0,1-2.324,4.339l-5.92,5.588A4.547,4.547,0,0,1,587.934,1934.754Zm6.015-14.6a4.636,4.636,0,0,0-3.074,1.341l-5.92,5.586c-.805.768-.605,2.348.441,3.45l.313.327a3.307,3.307,0,0,0,1.937,1.03,1.832,1.832,0,0,0,1.486-.412l5.918-5.588a4.761,4.761,0,0,0,1.462-2.678,2.424,2.424,0,0,0-.535-2.065l-.313-.33A2.306,2.306,0,0,0,593.95,1920.149Z",
    transform: "translate(-581.616 -1917.306)",
    fill: "#000f48"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5177",
    "data-name": "Trac\\xE9 5177",
    d: "M557.2,1943.352l14.765,14.773,4.808-4.793c14.6,1.07,20.455-8.278,21.914-9.981Z",
    transform: "translate(-537.932 -1877.383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5178",
    "data-name": "Trac\\xE9 5178",
    d: "M567.26,1959.521l-2.014-2.021,5.27-5.251.65.046c12.595.951,18.137-6.176,20.219-8.85.205-.263.373-.479.508-.634l2.165,1.853c-.111.132-.251.313-.422.534-2.083,2.671-8.363,10.706-22.023,9.986Z",
    transform: "translate(-532.22 -1877.768)",
    fill: "#000f48"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_707",
    "data-name": "Groupe 707",
    transform: "translate(30.323 1.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5179",
    "data-name": "Trac\\xE9 5179",
    d: "M595.864,1969.4H570.209a5.709,5.709,0,0,1-5.709-5.7c0-11.928,0-39.4,0-51.331a5.693,5.693,0,0,1,5.7-5.7l25.657,0a5.718,5.718,0,0,1,5.719,5.7c0,11.928,0,39.4,0,51.331A5.707,5.707,0,0,1,595.864,1969.4Z",
    transform: "translate(-563.073 -1905.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5180",
    "data-name": "Trac\\xE9 5180",
    d: "M596.457,1971.416H570.8a7.141,7.141,0,0,1-7.135-7.13v-51.329a7.123,7.123,0,0,1,7.122-7.125l25.657,0h0a7.143,7.143,0,0,1,7.141,7.129v51.329a7.129,7.129,0,0,1-7.13,7.13Zm-.01-62.736h0l-25.659,0a4.267,4.267,0,0,0-4.27,4.273v51.329a4.285,4.285,0,0,0,4.283,4.278h25.657a4.273,4.273,0,0,0,4.278-4.278v-51.329a4.288,4.288,0,0,0-4.288-4.276Z",
    transform: "translate(-563.665 -1905.828)",
    fill: "#000f48"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5181",
    "data-name": "Trac\\xE9 5181",
    d: "M603.587,1956.458H563.665v-45.626h39.922Zm-37.07-2.852h34.218v-39.923H566.517Z",
    transform: "translate(-533.342 -1900.469)",
    fill: "#000f48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5182",
    "data-name": "Trac\\xE9 5182",
    d: "M572.16,1938.882a51.234,51.234,0,0,0,2.572-12.822,11.085,11.085,0,0,0-2.315-7.429c-1.358-1.9-4.67-1.466-5.335.663-2.927,9.37-3.476,11.92-5.287,16.627-2.026,5.263-1.872,12.426-1.872,14.809a5.258,5.258,0,0,1-1.78,3.567c-1.452,1.452-3.329,3.379-3.329,3.379l13.135,13.142,7.067-7.069C578.9,1952.644,575.677,1943.325,572.16,1938.882Z",
    transform: "translate(-539.626 -1895.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_708",
    "data-name": "Groupe 708",
    transform: "translate(64.545 53.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5183",
    "data-name": "Trac\\xE9 5183",
    d: "M586.557,1946.843l-.313-.27c-1.607-1.385-2.2-3.35-1.329-4.365l3.731-4.293a3.819,3.819,0,0,1,5.374-.322l.313.27a3.817,3.817,0,0,1,.47,5.362l-3.733,4.294C590.2,1948.534,588.164,1948.23,586.557,1946.843Z",
    transform: "translate(-583.088 -1935.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5184",
    "data-name": "Trac\\xE9 5184",
    d: "M590.158,1950.137a4.765,4.765,0,0,1-.689-.051,6.622,6.622,0,0,1-3.249-1.568l-.313-.269c-2.245-1.939-2.895-4.741-1.481-6.381l3.736-4.3a5.24,5.24,0,0,1,7.381-.467l.315.272a5.238,5.238,0,0,1,.616,7.373l-3.734,4.3A3.329,3.329,0,0,1,590.158,1950.137Zm1.9-11.484a2.282,2.282,0,0,0-1.739.783l-3.736,4.3c-.166.193-.024,1.31,1.185,2.353l.313.268a3.811,3.811,0,0,0,1.811.91.9.9,0,0,0,.692-.086l3.736-4.3a2.384,2.384,0,0,0-.325-3.346l-.314-.272A2.489,2.489,0,0,0,592.057,1938.654Z",
    transform: "translate(-583.679 -1935.805)",
    fill: "#000f48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_709",
    "data-name": "Groupe 709",
    transform: "translate(3.094 57.532)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_468",
    "data-name": "Rectangle 468",
    width: 10.943,
    height: 33.053,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 1.827, 9.559)",
    fill: "#41c850"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5185",
    "data-name": "Trac\\xE9 5185",
    d: "M572.931,1973.184l-25.19-25.206,9.568-9.56,25.188,25.2Zm-21.54-25.206,21.541,21.555,5.914-5.911-21.539-21.555Z",
    transform: "translate(-547.741 -1938.418)",
    fill: "#000f48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_710",
    "data-name": "Groupe 710",
    transform: "translate(64.536 42.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5186",
    "data-name": "Trac\\xE9 5186",
    d: "M586.589,1941.067l-.318-.273c-1.635-1.411-2.243-3.409-1.353-4.442l3.8-4.369a3.886,3.886,0,0,1,5.468-.327l.318.273a3.886,3.886,0,0,1,.479,5.456l-3.8,4.369C590.291,1942.787,588.224,1942.477,586.589,1941.067Z",
    transform: "translate(-583.083 -1929.258)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5187",
    "data-name": "Trac\\xE9 5187",
    d: "M590.246,1944.382a6.3,6.3,0,0,1-4-1.642l0,0-.318-.275a6.68,6.68,0,0,1-2.054-3.023,3.548,3.548,0,0,1,.554-3.427l3.8-4.372a5.148,5.148,0,0,1,3.627-1.778,5.381,5.381,0,0,1,3.849,1.308l.318.275a5.365,5.365,0,0,1,1.855,3.613,5.149,5.149,0,0,1-1.229,3.853l-3.8,4.372A3.343,3.343,0,0,1,590.246,1944.382Zm-2.134-3.8c1.18,1.012,2.373,1.072,2.58.835l3.8-4.374a2.317,2.317,0,0,0,.545-1.734,2.53,2.53,0,0,0-.877-1.7l-.32-.277a2.547,2.547,0,0,0-1.816-.619,2.334,2.334,0,0,0-1.641.8l-3.8,4.372a.945.945,0,0,0,.017.727,3.89,3.89,0,0,0,1.192,1.7Z",
    transform: "translate(-583.674 -1929.851)",
    fill: "#000f48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_711",
    "data-name": "Groupe 711",
    transform: "translate(64.536 33.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5188",
    "data-name": "Trac\\xE9 5188",
    d: "M586.59,1935.389l-.32-.275c-1.635-1.409-2.243-3.41-1.352-4.44l3.8-4.369a3.886,3.886,0,0,1,5.468-.327l.318.274a3.885,3.885,0,0,1,.477,5.456l-3.8,4.369C590.29,1937.109,588.224,1936.8,586.59,1935.389Z",
    transform: "translate(-583.083 -1923.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5189",
    "data-name": "Trac\\xE9 5189",
    d: "M590.245,1938.7a6.3,6.3,0,0,1-4-1.641l-.318-.274c-2.272-1.961-2.932-4.8-1.5-6.455l3.8-4.372a5.3,5.3,0,0,1,7.476-.472l.316.273a5.307,5.307,0,0,1,.626,7.469l-3.8,4.372A3.343,3.343,0,0,1,590.245,1938.7Zm1.927-11.68a2.346,2.346,0,0,0-1.787.8l-3.8,4.372c-.205.241.031,1.413,1.209,2.428l.318.274c1.178,1.019,2.373,1.079,2.582.836l3.8-4.371a2.454,2.454,0,0,0-.333-3.444l-.316-.272A2.56,2.56,0,0,0,592.172,1927.024Z",
    transform: "translate(-583.674 -1924.172)",
    fill: "#000f48"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_469",
    "data-name": "Rectangle 469",
    width: 5.703,
    height: 2.852,
    transform: "translate(48.858 58.839)",
    fill: "#000f48"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_712",
    "data-name": "Groupe 712",
    transform: "translate(39.013 19.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5190",
    "data-name": "Trac\\xE9 5190",
    d: "M580.909,1916.668l3.977,7.14,7.43,1.378-4.972,6.8.615,7.392-7.05-2.283-7.05,2.386.615-7.52-4.972-6.776,7.43-1.378Z",
    transform: "translate(-568.212 -1915.426)",
    fill: "#41c850"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5191",
    "data-name": "Trac\\xE9 5191",
    d: "M574.394,1941.288a1.289,1.289,0,0,1-1.286-1.4l.576-7.04-4.687-6.39a1.29,1.29,0,0,1,.805-2.031l6.833-1.267,3.68-6.609a1.344,1.344,0,0,1,2.257,0l3.681,6.609,6.833,1.267a1.289,1.289,0,0,1,.805,2.03l-4.689,6.412.576,6.913a1.291,1.291,0,0,1-1.684,1.335l-6.641-2.151-6.646,2.249A1.237,1.237,0,0,1,574.394,1941.288Zm-2.1-14.691,3.755,5.118a1.284,1.284,0,0,1,.246.869l-.455,5.563,5.19-1.756a1.294,1.294,0,0,1,.812-.005l5.2,1.686-.457-5.461a1.306,1.306,0,0,1,.245-.869l3.762-5.144-5.412-1a1.3,1.3,0,0,1-.893-.641l-2.849-5.116-2.848,5.116a1.3,1.3,0,0,1-.893.641Z",
    transform: "translate(-568.748 -1915.942)",
    fill: "#000f48"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5192",
    "data-name": "Trac\\xE9 5192",
    d: "M576.785,1964.813l-2.691-.942c3.618-10.335.846-19.127-2.628-23.513l-.477-.605.243-.728a49.785,49.785,0,0,0,2.505-12.506,9.574,9.574,0,0,0-2.057-6.468,1.69,1.69,0,0,0-1.652-.583,1.4,1.4,0,0,0-1.161.843c-1.028,3.29-1.761,5.738-2.36,7.734-1.1,3.666-1.765,5.879-2.958,8.982-1.809,4.7-1.787,11.087-1.778,13.816l0,.481a6.6,6.6,0,0,1-2.2,4.576c-1.446,1.445-3.315,3.363-3.317,3.365l-2.042-1.99s1.884-1.934,3.343-3.393a4,4,0,0,0,1.361-2.558v-.47c-.01-2.89-.034-9.652,1.966-14.852,1.156-3,1.771-5.051,2.888-8.777.6-2,1.339-4.459,2.371-7.765a4.194,4.194,0,0,1,3.432-2.808,4.5,4.5,0,0,1,4.422,1.743,12.311,12.311,0,0,1,2.575,8.392,52.3,52.3,0,0,1-2.4,12.424C577.867,1944.336,580.625,1953.844,576.785,1964.813Z",
    transform: "translate(-540.05 -1896.382)",
    fill: "#000f48"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoAppliSimpleSoluspots);
export default __webpack_public_path__ + "static/media/PICTO_APPLI_SIMPLE_SOLUSPOTS.9ca1436cf9fa8db1473a13fa21582d46.svg";
export { ForwardRef as ReactComponent };